import './SiteLayoutLoadingContainer.scss';
import React from 'react';

export const SiteLayoutLoadingContainer = ({ children }) => {
    return <div className="site-layout__loading-container">{children}</div>;
};
